import { useDataGrid } from 'admin';
import type { MaterialProductInfoListItem } from 'api';
import { Form, useForm, useSyncFormFieldsWithFilters } from 'form';
import { Link, useNavigate } from 'react-router-dom';
import { Button, DataGrid, Page, Section } from 'ui';
import { ClassOutlined } from 'ui/icons';

import { MaterialProductsListFilters } from '../../components/MaterialProductsListFilters/MaterialProductsListFilter';
import { columns } from './columns';

export const MaterialProductsList = () => {
  const navigate = useNavigate();
  const { dataGridProps, setFilters } = useDataGrid({
    filters: {
      mode: 'server',
    },
    resource: '/materials/v1/material-products/',
  });
  const form = useForm();

  useSyncFormFieldsWithFilters(form, setFilters);

  return (
    <Page>
      <Section
        title="Material products"
        icon={ClassOutlined}
        action={
          <Button size="medium" component={Link} to="/ground-control/material-products/create">
            Create Material Product
          </Button>
        }
      >
        <Form {...form}>
          <MaterialProductsListFilters />
        </Form>
        <DataGrid<MaterialProductInfoListItem>
          {...dataGridProps}
          data-testid="material-products-list"
          showColumnVerticalBorder
          showCellVerticalBorder
          disableColumnFilter={true}
          autoHeight
          columns={columns}
          filterDebounceMs={500}
          density="compact"
          sx={{ cursor: 'pointer' }}
          onRowClick={(params) => {
            navigate(`/ground-control/material-products/${params.row.id}`);
          }}
        />
      </Section>
    </Page>
  );
};
